export default "__VITE_ASSET__Bsy6jIkX__"